import { compose, filter, prop, propOr, values } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';
import user from 'features/views/user';
import {
	getAllowedRegions,
	getAllowedRegionsByChannel,
	getAllowedRegionsOnlyByCampaignId,
} from 'features/views/user/selectors';

import { byChannelId, restrictBy } from '../utils';
import { NAME } from './constants';

const getRoot = prop(NAME);

export const getIdkRegions = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'idk'));
export const getEdkRegions = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'edk'));
export const getAllRegions = createSelector(getIdkRegions, getEdkRegions, (idk, edk) => idk.concat(edk));

// mix of three cases
export const getOrganizationStructureAllowedRegions = createSelector(
	(state) => state,
	(state, isGuarantor) => isGuarantor,
	(state, isGuarantor, channel) => channel,
	(state, isGuarantor, channel, campaignId) => campaignId,
	getIdkRegions,
	(state, isGuarantor, channel, campaignId, regions) => {
		const currentPathname = document.location.pathname;

		let allowedRegions;
		// temp fix
		if (isGuarantor) {
			if (currentPathname === '/contacts') {
				// contacts page - show all regions based only on role and roleStructureMap - no channel
				allowedRegions = getAllowedRegions(state);
			} else {
				// campaignManagement page with campaignId as guarantor
				// show regions based on campaignId
				allowedRegions = getAllowedRegionsOnlyByCampaignId(state, campaignId);
			}
		} else {
			// other roles - show regions based on channel
			allowedRegions = getAllowedRegionsByChannel(state, channel);
		}

		return compose(restrictBy(allowedRegions), filter(byChannelId(channel)), values)(regions);
	},
);

// special logic for sidebar orgStructure element
export const getOrganizationStructureAllowedRegionsForSidebar = createSelector(
	getIdkRegions,
	user.selectors.getAllowedRegions,
	(state, isGuarantor, channel, campaignId) => user.selectors.getAllowedRegionsOnlyByCampaignId(state, campaignId),
	(state, isGuarantor) => isGuarantor,
	(state, isGuarantor, channel) => channel,
	(state, isGuarantor, channel, campaignId, customAllowedRegions) => customAllowedRegions,
	(regions, baseAllowedRegions, allowedRegionsOnlyByCampaignId, isGuarantor, channel, customAllowedRegions) => {
		const userAllowedRegions = isGuarantor ? allowedRegionsOnlyByCampaignId : baseAllowedRegions;

		return compose(
			restrictBy(customAllowedRegions),
			restrictBy(userAllowedRegions),
			filter(byChannelId(channel)),
			values,
		)(regions);
	},
);
